"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _BreakdownScoreContainer = _interopRequireDefault(require("../BreakdownScoreContainer"));

var _ResultSection = _interopRequireDefault(require("../result/ResultSection"));

var _RadialProgressBar = _interopRequireDefault(require("../RadialProgressBar"));

var _OverallData = _interopRequireDefault(require("../../data/components/OverallData"));

var _OverallResultSection = _interopRequireDefault(require("../result/OverallResultSection"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _TrialConstants = require("../../constants/TrialConstants");

var _usageTracker = _interopRequireDefault(require("../../lib/usageTracker"));

var _Urls = require("../../util/Urls");

var NoCreditCard = function NoCreditCard() {
  return _react.default.createElement("span", {
    className: "no-credit-card"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "results.sidePanel.overallGrade.cta.noCreditCard"
  }));
};

var CTABottom = function CTABottom(_ref) {
  var onClick = _ref.onClick;
  var parsedUtmParams = (0, _Urls.parseUtmParams)();
  return _react.default.createElement("div", {
    className: "cta-section"
  }, _react.default.createElement("div", {
    className: "cta-title"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "results.sidePanel.overallGrade.cta.title"
  })), _react.default.createElement("div", {
    className: "cta-microcopy"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "results.sidePanel.overallGrade.cta.microcopy"
  })), _react.default.createElement("a", {
    className: "button white",
    target: "_blank",
    rel: "noopener noreferrer",
    href: _TrialConstants.MON109_CMS_DTT_LINK + "&" + parsedUtmParams,
    onClick: onClick
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "trialBanner.ctaButton"
  })), _react.default.createElement(NoCreditCard, null));
};

var handleClick = function handleClick(_ref2) {
  var websiteUrl = _ref2.websiteUrl;

  _usageTracker.default.log('trialBannerClick', {
    type: 'dtt-cta-click',
    websiteUrl: websiteUrl,
    source: 'trial-cta-sidepanel'
  });
};

var _default = function _default(_ref3) {
  var websiteGrade = _ref3.websiteGrade;
  var url = websiteGrade.get('domain');
  var grade = websiteGrade.get('overallGrade');
  var overallData = new _OverallData.default().init(grade);
  var gradeType = overallData.gradeType;
  return _react.default.createElement("div", {
    className: "sidepanel-overall-grade"
  }, _react.default.createElement("div", null, _react.default.createElement(_ResultSection.default, {
    gradeType: gradeType
  }, _react.default.createElement(_RadialProgressBar.default, {
    score: grade
  }, grade), _react.default.createElement("div", {
    className: "website-url"
  }, url), _react.default.createElement("div", {
    className: "side-panel-result-section"
  }, _react.default.createElement(_OverallResultSection.default, {
    websiteGrade: websiteGrade
  })), _react.default.createElement(_BreakdownScoreContainer.default, {
    websiteGrade: websiteGrade
  }), _react.default.createElement(CTABottom, {
    onClick: function onClick() {
      return handleClick({
        websiteUrl: url
      });
    }
  }))));
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/sidepanel/OverallGrade.js
// module id = 309
// module chunks = 0